import {createAction} from "@reduxjs/toolkit";

export const setInfopages = createAction('SET_INFOPAGES');